/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use the new Themed Text component from "components/Themed" instead.
 *
 * Migration guide:
 * - Import { Text } from "components/Themed"
 * - Replace styled-system props with typography prop
 * - For text truncation, use the LimitLineText component
 *
 * Example:
 * Before: <Text fontSize="14px" limitLines={2}>Hello</Text>
 * After: <Text typography="p1">Hello</Text>
 */

import styled from "styled-components";
import { typography, system } from "styled-system";
import Div from "../Div";

export default styled(Div)`
  ${typography}
  ${system({
    textTransform: true,
    textDecoration: true,
    overflowWrap: true,
  })}
  scroll-margin: ${({ scrollMargin }) => scrollMargin ?? null};

  ${({ limitLines }) =>
    limitLines &&
    `
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: ${limitLines};
    -webkit-box-orient: vertical;
  `}
`;
